import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "modal--content potReactoinModal" }
const _hoisted_2 = { class: "modalInnerContent" }
const _hoisted_3 = { class: "headerDv justify-content-between" }
const _hoisted_4 = {
  key: 0,
  class: "tabs-header"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  class: "reaction-icon"
}
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { class: "users-list" }
const _hoisted_11 = {
  key: 0,
  class: "loading-state"
}
const _hoisted_12 = {
  key: 1,
  class: "no-data-state"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "user-name" }
const _hoisted_15 = { class: "user-handle" }
const _hoisted_16 = {
  key: 0,
  class: "ButtonDv"
}
const _hoisted_17 = {
  key: 0,
  class: "follow-btn"
}
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = {
  key: 1,
  class: "ButtonDv"
}
const _hoisted_21 = {
  key: 0,
  class: "load-more-container"
}
const _hoisted_22 = ["disabled"]
const _hoisted_23 = {
  key: 0,
  class: "loader load-more-loader"
}
const _hoisted_24 = { key: 1 }

import { ref, computed, onMounted } from "vue";
import IconComponent from "@/components/IconComponent.vue";
import ProfileAvatarComponent from "@/components/ProfileAvatarComponent.vue";
import utilService from "@/services/util.service";
import { popModal } from "jenesius-vue-modal";
import httpService from "@/services/http.service";
import storageService from "@/services/storage.service";
import { ConnectionComposables } from "@/composables/connection/connection.composable";
import router from "@/router/router";
import { RouteEnum } from "@/router/routeNames";
import { useReactionStore } from "@/services/reaction.store";
import { useI18n } from "vue-i18n";

const PAGE_SIZE = 10;


export default /*@__PURE__*/_defineComponent({
  __name: 'PostReactionDetailPopup',
  props: {
    sourceId: {}
  },
  setup(__props: any) {

const props = __props;

const reactions = ref<any[]>([]);
const connectionsLoading = ref(false);
const loadMoreLoading = ref(false);
const activeTab = ref("all");
const currentPage = ref(1);
const hasMore = ref(false);
const { onFollow, unfollow } = ConnectionComposables();
const reactionStore = useReactionStore();
const { t } = useI18n();

// Individual loading states for each user
const userLoadingStates = ref<{ [key: string]: boolean }>({});

const currentUser = computed(() => {
  if (storageService.user.value && storageService.user.value._id) {
    return storageService.user.value;
  }
  return null;
});

const goToProfile = (data: any) => {
  closeModal();
  router.push({
    name: RouteEnum.profile,
    params: { username: data },
  });
};

const reactionCounts = computed(() =>
  reactionStore.getAllReactionCountsForPost(props.sourceId)
);

const totalReactionCount = computed(() =>
  Object.values(reactionCounts.value).reduce(
    (sum, count) => sum + (count || 0),
    0
  )
);

const hasReactionData = computed(
  () => totalReactionCount.value > 0 || reactions.value.length > 0
);

// Reaction tabs configuration
const reactionTabs = computed(() => {
  const tabs = [
    { type: "all", label: "All", count: totalReactionCount.value },
  ];

  Object.entries(reactionCounts.value).forEach(([type, count]) => {
    if (count > 0) {
      tabs.push({
        type,
        label: getReactionLabel(type),
        count,
      });
    }
  });

  return tabs;
});

// Function to get human-readable labels for reaction types
const getReactionLabel = (type: string): string => {
  const labels: { [key: string]: string } = {
    like: "Like",
    sadbull: "Sad Bull",
    heart: "Heart",
    angrybull: "Angry Bull",
    shock: "Shock",
    shocked: "Shocked",
    smirkingbull: "Smirking Bull",
    appreciated: "Appreciated",
    bloodbath: "Bloodbath",
    crapmine: "Crap Mine",
    crashingdown: "Crashing Down",
    cryptomarket: "Crypto Market",
    deadweight: "Dead Weight",
    diamondhand: "Diamond Hand",
    downchart: "Down Chart",
    feelingsick: "Feeling Sick",
    allgreen: "All Green",
    goldmine: "Gold Mine",
    kingofthemarket: "King of Market",
    kiss: "Kiss",
    queenofthemarket: "Queen of Market",
    tothemood: "To The Mood",
    upchart: "Up Chart",
  };
  return labels[type] || type.charAt(0).toUpperCase() + type.slice(1);
};

const buildFetchParams = (page: number) => {
  const params: { page: number; count: number; type?: string } = {
    page,
    count: PAGE_SIZE,
  };

  if (activeTab.value !== "all") {
    params.type = activeTab.value;
  }

  return params;
};

const fetchReactions = async (append = false) => {
  try {
    if (append) {
      loadMoreLoading.value = true;
    } else {
      connectionsLoading.value = true;
    }

    const page = append ? currentPage.value + 1 : 1;
    const response = await httpService.getDetailedReactions(
      props.sourceId,
      buildFetchParams(page)
    );
    const items = response || [];

    if (append) {
      currentPage.value = page;
      reactions.value = [...reactions.value, ...items];
    } else {
      currentPage.value = 1;
      reactions.value = items;
    }

    hasMore.value = items.length === PAGE_SIZE;
  } catch (e) {
    console.log("error", e);
    if (!append) {
      reactions.value = [];
    }
    hasMore.value = false;
  } finally {
    connectionsLoading.value = false;
    loadMoreLoading.value = false;
  }
};

// Set active tab
const setActiveTab = async (tabType: string) => {
  if (activeTab.value === tabType) return;
  activeTab.value = tabType;
  await fetchReactions(false);
};

const loadMoreReactions = () => fetchReactions(true);

// API already filters by type when a tab is selected
const filteredReactions = computed(() => reactions.value);

// Follow/Unfollow functions
const followUser = async (profile: any) => {
  console.log("followUser", profile);
  document.body.click();
  userLoadingStates.value[profile.userId] = true; // Set loading state for the specific user
  try {
    await onFollow(profile);
  } catch (error) {
    console.error("Error following user:", error);
  } finally {
    userLoadingStates.value[profile.userId] = false; // Reset loading state after completion
  }
};

const unfollowUser = async (userId: string) => {
  document.body.click();
  userLoadingStates.value[userId] = true; // Set loading state for the specific user
  try {
    await unfollow(userId);
  } catch (error) {
    console.error("Error unfollowing user:", error);
  } finally {
    userLoadingStates.value[userId] = false; // Reset loading state after completion
  }
};

onMounted(async () => {
  await fetchReactions(false);
});

// Store user images like in TopPeopleComponent
const userImages = ref<{ [key: string]: string }>({});

// Function to get user profile image using utilService
const getUserProfileImage = (userId: string, profilePicture: number) => {
  if (!userImages.value[userId]) {
    userImages.value[userId] = utilService.getUserProfilePicture(
      userId,
      profilePicture,
      "male",
      false,
      false
    );
  }
  return userImages.value[userId];
};

const closeModal = () => popModal();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (hasReactionData.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reactionTabs.value, (tab) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: tab.type,
                  class: _normalizeClass(["tabs-header-item", { active: activeTab.value === tab.type, disabled: connectionsLoading.value }]),
                  onClick: ($event: any) => (!connectionsLoading.value && setActiveTab(tab.type))
                }, [
                  (tab.type !== 'all')
                    ? (_openBlock(), _createElementBlock("figure", _hoisted_6, [
                        _createElementVNode("img", {
                          src: require(`@/assets/images/reactions/${tab.type}.png`),
                          alt: tab.label
                        }, null, 8, _hoisted_7)
                      ]))
                    : _createCommentVNode("", true),
                  (tab.type !== 'all')
                    ? (_openBlock(), _createElementBlock("p", _hoisted_8, "(" + _toDisplayString(tab.count) + ")", 1))
                    : (_openBlock(), _createElementBlock("p", _hoisted_9, "All (" + _toDisplayString(tab.count) + ")", 1))
                ], 10, _hoisted_5))
              }), 128)),
              _cache[1] || (_cache[1] = _createElementVNode("div", null, null, -1))
            ]))
          : _createCommentVNode("", true),
        _createVNode(IconComponent, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (closeModal())),
          class: "newHeadericon",
          icon: "close-times.svg"
        })
      ]),
      _createElementVNode("div", _hoisted_10, [
        (connectionsLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, _cache[2] || (_cache[2] = [
              _createElementVNode("div", { class: "loader" }, null, -1),
              _createElementVNode("span", null, "Loading reactions...", -1)
            ])))
          : (filteredReactions.value.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, _cache[3] || (_cache[3] = [
                _createElementVNode("span", null, "No reactions found", -1)
              ])))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredReactions.value, (reaction) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: reaction._id,
                    class: "user-row"
                  }, [
                    _createElementVNode("div", {
                      class: "user-row-left",
                      onClick: ($event: any) => (goToProfile(reaction.userName))
                    }, [
                      _createVNode(ProfileAvatarComponent, {
                        class: "small",
                        profileImage: 
                getUserProfileImage(
                  reaction.userId,
                  reaction.userProfilePicture || 0
                )
              ,
                        userId: reaction.userId,
                        border: true,
                        badges: false,
                        camera: false,
                        showReaction: true,
                        reaction: reaction.reactionType
                      }, null, 8, ["profileImage", "userId", "reaction"]),
                      _createElementVNode("p", _hoisted_14, _toDisplayString(reaction.userFullName), 1),
                      _createElementVNode("p", _hoisted_15, "@" + _toDisplayString(reaction.userName), 1)
                    ], 8, _hoisted_13),
                    (currentUser.value && currentUser.value._id !== reaction.userId)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          (userLoadingStates.value[reaction.userId])
                            ? (_openBlock(), _createElementBlock("a", _hoisted_17, _cache[4] || (_cache[4] = [
                                _createElementVNode("div", {
                                  class: "loader follow-loader",
                                  style: {"margin":"0px auto"}
                                }, null, -1)
                              ])))
                            : (!reaction.isFollowing)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 1,
                                  class: "follow-btn",
                                  onClick: ($event: any) => (followUser(reaction))
                                }, [
                                  _createVNode(IconComponent, { icon: "icon-follow-button.svg" }),
                                  _cache[5] || (_cache[5] = _createTextVNode(" Follow", -1))
                                ], 8, _hoisted_18))
                              : (_openBlock(), _createElementBlock("a", {
                                  key: 2,
                                  class: "following-btn",
                                  onClick: ($event: any) => (unfollowUser(reaction.userId))
                                }, [
                                  _createVNode(IconComponent, {
                                    class: "unfollowUser",
                                    icon: "icon-button-unfollowing.svg"
                                  }),
                                  _cache[6] || (_cache[6] = _createTextVNode(" Following", -1))
                                ], 8, _hoisted_19))
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_20, _cache[7] || (_cache[7] = [
                          _createElementVNode("a", { class: "following-btn" }, " You ", -1)
                        ])))
                  ]))
                }), 128)),
                (hasMore.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _createElementVNode("button", {
                        class: "load-more-btn",
                        disabled: loadMoreLoading.value,
                        onClick: loadMoreReactions
                      }, [
                        (loadMoreLoading.value)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_23))
                          : (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_unref(t)("common.actions.loadMore")), 1))
                      ], 8, _hoisted_22)
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
      ])
    ])
  ]))
}
}

})